import { gql } from "@apollo/client";

/**
 * Public, unauthenticated. Pinned by the shop on their Page so a buyer whose bill has not arrived can
 * confirm their order exists instead of commenting again — which would create a duplicate
 * order and burn a second private-reply slot on a Page already at its quota.
 */
export const FIND_MY_ORDERS = gql`
  query FindMyOrders($shopId: String!, $nameQuery: String!) {
    findMyOrders(shopId: $shopId, nameQuery: $nameQuery) {
      shopName
      pageName
      windowHours
      truncated
      error
      orders {
        maskedName
        code
        itemCount
        totalPrice
        currency
        createdAt
        deliveryState
        advice
        greetLink
      }
    }
  }
`;
